import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/Tooltip"
import { formatMoneyShort } from "@/lib/money"
import { num } from "../format"
import type { Excess } from "../types"

// Excess value over excess units. The tooltip says how the units are counted,
// since that is what the list is sorted by.
export default function ExcessCell({ excess, cutoff, currency }: { excess: Excess; cutoff: number; currency: string }) {
  const units = `${num(excess.units)} ${excess.units === 1 ? "unit" : "units"}`
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <span className="flex w-20 flex-col items-end tabular-nums">
          <span className="text-sm font-semibold">{formatMoneyShort(excess.value, currency)}</span>
          <span className="text-xs">{units}</span>
        </span>
      </TooltipTrigger>
      <TooltipContent className="max-w-xs">
        {units} on hand won't sell within {cutoff} days at today's pace.{" "}
        Worth {formatMoneyShort(excess.value, currency)} at buying price.
      </TooltipContent>
    </Tooltip>
  )
}
